import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { TextField } from "@material-ui/core";
import moment from "moment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import clientService from "./../../../services/MarketingService/ClientService";
import publicationService from "./../../../services/MarketingService/PublicationService";

const localizer = momentLocalizer(moment);

function MyCalendar() {
  const [events, setEvents] = useState([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  const [PiecesJoints, setPiecesJoints] = useState("");
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [type, setType] = useState("");
  const [typesData, setTypesData] = useState([]);
  const [genresData, setGenresData] = useState([]);

  const [selectedType, setSelectedType] = useState(null);
  const [canalDiffusion, setCanalDiffusion] = useState("");
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);
  const [selectedCanalDiffusion, setSelectedCanalDiffusion] = useState(null);
  const [objectif, setObjectif] = useState("");
  const [objectifsData, setObjectifsData] = useState([]);
  const [publicationDate, setpublicationDate] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [selectedEventId, setSelectedEventId] = useState(null);

  const formattedDateTime = moment(events.publicationDate).format(
    "yyyy-MM-ddThh:mm"
  );

  //for edit
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    nom: "",
    objectif: "",
    contenu: "",
    canalDiffusion: "",
    type: "",
    genreCible: "",
    ageCible: "",
    lieuCible: "",
    publicationDate: "",
    PiecesJoints: "",
    idPublication: "",
  });
  // change date de publication
  const onChangeStartDate = (event) => {
    setFormData({
      ...formData,
      publicationDate: event.target.value,
    });
  };
  useEffect(() => {
    fetchEvents();
  });

  useEffect(() => {
    AfficherListTypes();
    AfficherListCanalDiffusion();
    AfficherListObjectifs();
    AfficherListGenres();
  }, []);

  // methode pou afficher les publications
  const fetchEvents = async () => {
    try {
      const response = await publicationService.AfficherListPublications();
      const events = response.data.success.map((event) => ({
        id: event.id,
        nom: event.nom,
        start: new Date(event.publicationDate),
        end: new Date(event.publicationDate),
        objectif: event.objectif,
        type: event.type,
        contenu: event.contenu,
        canalDiffusion: event.canalDiffusion,
        cible: event.cible,
        publicationDate: event.publicationDate,
        statut: event.statut,
        idPublication: event.idPublication,
        genreCible: event.genreCible,
        ageCible: event.ageCible,
        lieuCible: event.lieuCible,
      }));
      setEvents(events);
    } catch (error) {
      console.error(error);
    }
  };

  // methode pour modifier couleur de data dans calendar
  const eventStyleGetter = (event) => {
    let style = {
      backgroundColor: event.color, // Use the color property of the event
    };

    if (event.statut === "Aprogrammer") {
      style = {
        ...style,
        backgroundColor: "green",
      };
    } else if (event.statut === "Rejeté") {
      style = {
        ...style,
        backgroundColor: "gray",
      };
    } else if (event.statut === "Planifié") {
      style = {
        ...style,
        backgroundColor: "bleu",
      };
    } else {
      style = {
        ...style,
        backgroundColor: "dark",
      };
    }

    return {
      style,
    };
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // methode pour mettre à jour l'état de la publication sélectionnée
  const handleSelectEvent = (event) => {
    setSelectedEvent(event);
    setFormData({
      nom: event.nom,
      objectif: event.objectif,
      contenu: event.contenu,
      canalDiffusion: event.canalDiffusion,
      type: event.type,
      cible: event.cible,
      publicationDate: moment(event.publicationDate).format("YYYY-MM-DDTHH:mm"),
      statut: event.statut,
      idPublication: event.idPublication,
      genreCible: event.genreCible,
      ageCible: event.ageCible,
      lieuCible: event.lieuCible,
    });
    setShowModal(true);
  };

  // methode pour Cancel : Annuler
  const handleCancel = () => {
    setShowModal(false);
    setSelectedEvent(null);
  };

  /****************  Get current user id **********************/
  const user = JSON.parse(localStorage.getItem("user")); // Fonction utilitaire pour extraire l'ID de l'utilisateur du token JWT
  const userId = user?.token.idUser; // Récupérer l'ID de l'utilisateur connecté
  const userRoles = user?.token.nameRole; //Récupérer le rôle de l'utilisateur connecté
  /****************  /.Get current user id **********************/
  /****************  methodes for approuver or rejected publication**********************/

  const handleApprouvedPublication = async (event) => {
    try {
      event.preventDefault();
      const id = selectedEvent.id;
      const response = await publicationService.approuvedStatut(
        id,
        userId,
        userRoles
      );
      if (response && response.id) {
        // Assuming response has a valid event object with an ID
        const updatedEvents = events.map((event) => {
          if (event.id === response.id) {
            // Update the color to "bleu" if approved
            return { ...response, color: "bleu" };
          }
          return event;
        });
        setEvents(updatedEvents);
      }
      setIsButtonDisabled(true);
      // fetchEvents();
      // notification d'ajout
      toast.success("Publication approuveé avec succès");
    } catch (error) {
      console.log(error);
      toast.error("Une erreur s'est produite lors de l'approuvation");
    }
  };

  const handleRjectedPublication = async (event) => {
    try {
      event.preventDefault();
      const id = selectedEvent.id;
      const response = await publicationService.rejectStatut(
        id,
        userId,
        userRoles
      );
      if (response && response.id) {
        // Assuming response has a valid event object with an ID
        const updatedEvents = events.map((event) => {
          if (event.id === response.id) {
            // Update the color to "bleu" if approved
            return { ...response, color: "bleu" };
          }
          return event;
        });
        setEvents(updatedEvents);
      }
      setIsButtonDisabled(true);
      // fetchEvents();
      // notification d'ajout
      toast.success("Publication rejeteé avec succès");
    } catch (error) {
      console.log(error);
      toast.error("Une erreur s'est produite lors de rjete");
    }
  };

  /****************  /.methodes for approuver or rejected publication**********************/

  // Gérer la sélection de fichiers joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };
  // Supprimer le dernier fichier joint de la liste
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];
    // Remove the last item from the array
    newPiecesJointesData.pop();
    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);
  };

  /****************  methode update publication **********************/

  const handleUpdatePublication = async (event) => {
    event.preventDefault();

    const {
      nom,
      contenu,
      canalDiffusion,
      type,
      genreCible,
      lieuCible,
      ageCible,
      objectif,
      publicationDate,
      PiecesJoints,
      statut,
      idPublication,
    } = formData;

    // Vérifier que tous les champs existent
    if (
      !nom ||
      !objectif ||
      !type ||
      !canalDiffusion ||
      !contenu ||
      !genreCible ||
      !lieuCible ||
      !ageCible ||
      !publicationDate
    ) {
      toast.error("Veuillez renseigner tous les champs !");
      return;
    }

    if (
      nom === selectedEvent.nom &&
      objectif === selectedEvent.objectif &&
      type === selectedEvent.type &&
      canalDiffusion === selectedEvent.canalDiffusion &&
      contenu === selectedEvent.contenu &&
      lieuCible === selectedEvent.lieuCible &&
      ageCible === selectedEvent.ageCible &&
      genreCible === selectedEvent.genreCible &&
      idPublication === selectedEvent.idPublication &&
      publicationDate ===
        moment(selectedEvent.publicationDate).format("YYYY-MM-DDTHH:mm")
    ) {
      // Vérifier si les champs ont été modifiés
      toast.error(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }
    // Vérifier si l'âge est une valeur entière
    if (!Number.isInteger(Number(idPublication))) {
      toast.error("Veuillez saisir id de publication valide !");
      return;
    }

    // Vérifier si l'âge est une valeur entière
    if (!Number.isInteger(Number(ageCible))) {
      toast.error("Veuillez saisir un âge valide !");
      return;
    }

    const currentDate = new Date();
    if (new Date(publicationDate) < currentDate) {
      toast.error(
        "La date de publication doit être supérieure ou égale à la date actuelle !"
      );
      return;
    }

    const updatedPublication = {
      ...formData,
      userIdCreation: userId,
      roleUserCreation: userRoles,
    };

    try {
      // Mettre à jour la publication avec les nouvelles informations et les images
      const images = piecesJointesdata ? piecesJointesdata : null;
      await publicationService.mettreAJourPublication(
        updatedPublication,
        images,
        selectedEvent.id
      );

      const updatedData = events.map((publication) =>
        publication.id === selectedEvent.id
          ? { ...publication, ...updatedPublication }
          : publication
      );
      setEvents(updatedData);
      setShowModal(false);
      setSelectedEvent(null);
      setPiecesJointesdata([]);

      // notification d'ajout
      toast.success("Publication modifiée avec succès");
    } catch (error) {
      console.log(error);
      toast.error("Une erreur s'est produite lors de la modification");
    }
  };

  /****************  /.methode update publication **********************/
  /****************  methode pour afficher genres **********************/

  const AfficherListGenres = () => {
    clientService
      .AfficherListGenres()
      .then((response) => {
        setGenresData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };
  /**************** /. methode pour afficher genres**********************/

  //methode pour afficher types
  const AfficherListObjectifs = () => {
    publicationService
      .AfficherListObjectifs()
      .then((response) => {
        setObjectifsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  /**************** Delete Modal **********************/
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleClose = (row) => {
    setShow(false);
    setInputValue("");
    setButtonDisabled(true);
  };

  const handleSelectEventForDelete = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await publicationService.supprimerPublication(selectedEvent.id);
      const newData = events.filter((item) => item.id !== selectedEvent.id);
      setEvents(newData);
      setShow(false);
      // Effacer la valeur de l'input "DELETE" après le clique sur le button supprimer
      setInputValue("");
      toast.success("Suppression validée avec succès");
      setButtonDisabled(true);
      setShowModal(false);
      setSelectedEvent(null);
    } catch (error) {
      console.log(error);
      toast.error("Une erreur s'est produite lors de suppression.");
      console.log(selectedEvent.id);
    }
  };

  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };

  /**************** /.Delete Modal **********************/

  //methode pour afficher types
  const AfficherListTypes = () => {
    publicationService
      .AfficherListTypes()
      .then((response) => {
        setTypesData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  //methode pour afficher Canal de Diffusions
  const AfficherListCanalDiffusion = () => {
    publicationService
      .AfficherListCanalDiffusion()
      .then((response) => {
        setCanalDiffusionsData(response.data.success);
      })
      .catch((error) => {
        console.log(error);
        setErreur(error.message);
      });
  };

  return (
    <div className="calendar-container">
      {/* notification d'ajout */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* /.notification d'ajout */}
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        titleAccessor={(event) => event.nom} // Utiliser la valeur de nom comme titre de l'événement
        onSelectEvent={handleSelectEvent}
        style={{ height: 500 }}
        //views={['week', 'day']} // Permet d'afficher les vues semaine et jour
        eventPropGetter={eventStyleGetter}
      />

      {/* EditEventModal */}
      <Modal
        show={showModal}
        onHide={handleCancel}
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <div
          className="card card-dark"
          style={{ boxShadow: "none", marginBottom: 0 }}
        >
          <div className="card-header">
            <h3 className="card-title">Modifier Publication </h3>
            <button className="close">
              <FontAwesomeIcon
                icon={faTimes}
                closeButton
                onClick={handleCancel}
                style={{ color: "white" }}
              />
            </button>
          </div>
          <form>
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Nom</label>
                <input
                  type="text"
                  className="form-control"
                  id="exampleInputEmail1"
                  placeholder="Nom"
                  name="nom"
                  value={formData.nom}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                />
              </div>
              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Objectif</label>
                <select
                  className="custom-select"
                  id="objectif"
                  name="objectif"
                  value={formData.objectif}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                >
                  {objectifsData?.map((objectif) => (
                    <option key={objectif} value={objectif}>
                      {objectif}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      Canal de diffusion
                    </label>
                    <select
                      className="custom-select"
                      id="canalDiffusion"
                      name="canalDiffusion"
                      value={formData.canalDiffusion}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {canalDiffusionsData?.map((canalDiffusion) => (
                        <option key={canalDiffusion} value={canalDiffusion}>
                          {canalDiffusion}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Type</label>
                    <select
                      className="custom-select"
                      id="type"
                      name="type"
                      value={formData.type}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {typesData?.map((type) => (
                        <option key={type} value={type}>
                          {type}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="exampleInputEmail1">Contenu</label>
                <textarea
                  className="form-control"
                  rows="3"
                  placeholder="Contenu ..."
                  name="contenu"
                  value={formData.contenu}
                  onChange={handleInputChange}
                  disabled={
                    userRoles.includes("COMMUNITY_MANAGER") &&
                    !(formData.statut === "planifié")
                  }
                ></textarea>
              </div>

              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Age Cible</label>
                    <input
                      type="text"
                      className="form-control"
                      id="ageCible"
                      placeholder="Age Cible"
                      name="ageCible"
                      value={formData.ageCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Lieu Cible</label>
                    <input
                      type="text"
                      className="form-control"
                      id="lieuCible"
                      placeholder="Lieu Cible"
                      name="lieuCible"
                      value={formData.lieuCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                  </div>

                  <div className="col">
                    <label htmlFor="exampleInputEmail1">Genre Cible</label>
                    <select
                      className="custom-select"
                      id="genreCible"
                      name="genreCible"
                      value={formData.genreCible}
                      onChange={handleInputChange}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    >
                      {genresData?.map((genre) => (
                        <option key={genre} value={genre}>
                          {genre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="form-group">
                <div className="row">
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      ID de Publication
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="exampleInputEmail1"
                      placeholder="Id de publication"
                      name="idPublication"
                      value={formData.idPublication}
                      onChange={handleInputChange}
                      disabled={userRoles.includes("RESPONSABLE_MARKETING")}
                    />
                  </div>
                  <div className="col">
                    <label htmlFor="exampleInputEmail1">
                      Date de publication
                    </label>

                    <TextField
                      variant="outlined"
                      className="form-control"
                      value={formData.publicationDate}
                      defaultValue={formattedDateTime}
                      name="publicationDate"
                      onChange={onChangeStartDate}
                      id="datetime-local"
                      type="datetime-local"
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      size="small"
                      // className="mt-2"
                      //style={{ backgroundColor: "white"}}
                    />
                  </div>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="pieces-jointes">Pieces jointes</label>
                <div className="input-group">
                  <div className="custom-file">
                    <input
                      type="file"
                      className="custom-file-input"
                      id="PiecesJoints"
                      name="PiecesJoints"
                      onChange={handlePieceJointeChange}
                      value={formData.PiecesJoints}
                      disabled={
                        userRoles.includes("COMMUNITY_MANAGER") &&
                        !(formData.statut === "planifié")
                      }
                    />
                    <label
                      className="custom-file-label"
                      htmlFor="pieces-jointes"
                    >
                      {piecesJointesdata.length === 0
                        ? "Choose file"
                        : piecesJointesdata
                            .map((fichier) => fichier.name)
                            .join(", ")}
                    </label>
                  </div>
                  {piecesJointesdata.length > 0 && (
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        type="button"
                        onClick={handleDeletePieceJointe}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  )}
                </div>
                {/* affichage des images  */}
                <div className="row mt-3">
                  {piecesJointesdata.map((fichier, index) => (
                    <div key={index} className="col-sm-3 text-center mb-3">
                      <img
                        src={URL.createObjectURL(fichier)}
                        alt={fichier.name}
                        style={{ width: "100%", height: "80%" }}
                      />
                      <button
                        className="btn btn-outline-danger col-sm mt-3 mb-3"
                        type="button"
                        onClick={() => handleDeletePieceJointe(index)}
                      >
                        <i className="fa fa-trash"></i>
                      </button>
                    </div>
                  ))}
                </div>
                {/* end of affichage des images  */}
              </div>
            </div>
          </form>
        </div>
        {/* condition sur les button Ajouter + annuler */}
        <div className="card-footer">
          <div className="row">
            {userRoles &&
              Array.isArray(userRoles) &&
              userRoles.includes("RESPONSABLE_MARKETING") && (
                <div className="col">
                  <Button
                    className="btn btn-danger mr-2"
                    style={{ width: "150px" }}
                    onClick={handleRjectedPublication}
                    disabled={
                      isButtonDisabled ||
                      formData.statut !== "planifié" ||
                      !selectedEvent
                    }
                  >
                    Rejeter
                  </Button>
                  <Button
                    className="btn btn-warning"
                    style={{ width: "150px" }}
                    onClick={handleApprouvedPublication}
                    disabled={
                      isButtonDisabled ||
                      formData.statut !== "planifié" ||
                      !selectedEvent
                    }
                  >
                    Approuver
                  </Button>
                </div>
              )}

            {/* condition sur les button Ajouter + annuler */}
            <div className="col text-right">
              <Button
                className="btn btn-secondary mr-2"
                style={{ width: "150px" }}
                onClick={handleCancel}
              >
                Annuler
              </Button>
              <Button
                className="btn btn-danger mr-2"
                style={{ width: "150px" }}
                onClick={handleSelectEventForDelete}
                disabled={
                  userRoles.includes("COMMUNITY_MANAGER") &&
                  !(formData.statut === "planifié")
                }
              >
                Supprimer
              </Button>
              <Button
                className="btn btn-warning"
                style={{ width: "150px" }}
                type="submit"
                onClick={handleUpdatePublication}
              >
                Modifier
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      {/* /.EditEventModal */}

      {/* DeleteModal */}

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <Modal.Title>Confirmation de suppression</Modal.Title>
          <button className="close">
            <FontAwesomeIcon icon={faTimes} closeButton onClick={handleClose} />
          </button>
        </Modal.Header>
        <Modal.Body>
          Êtes-vous sûr(e) de vouloir supprimer ?<br />
          <br />
          <strong>Date de Publication : </strong>
          {selectedEvent && selectedEvent.publicationDate && (
            <>
              {new Date(selectedEvent.publicationDate)
                .toLocaleDateString("fr-FR", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                })
                .replace(/\//g, "-")}
            </>
          )}
          <br />
          <strong>Nom : </strong>
          {selectedEvent && selectedEvent.nom}
          <br />
          <br />
          <br />
          <p>
            Tapper le mot <strong>DELETE</strong> pour pouvez supprimer Data
          </p>
          <input
            type="text"
            className="form-control"
            placeholder="DELETE"
            value={inputValue}
            onChange={handleInputChangeDelete}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Annuler
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDelete}
            disabled={buttonDisabled}
          >
            Supprimer
          </Button>
        </Modal.Footer>
      </Modal>

      {/* /.DeleteModal */}
    </div>
  );
}

export default MyCalendar;
